/*
 *     Copyright (c) 2020 Bcame S.r.l.. All rights reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */
export default {
  setAdminToken (state, token) {
    state.token = token
  },
  setStoreCode (state, code) {
    state.storeCode = code
  },
  setUserType (state, type) {
    state.userType = type
  },
  setStoreId (state, id) {
    state.storeId = id
  },
  setUserStoreId (state, id) {
    state.userStoreId = id
  },
  setOnlineMode (state, boolVal) {
    state.isOnlineMode = boolVal
  },
  setAdmin (state, admin) {
    admin && admin.addresses && admin.addresses.length && admin.addresses.forEach(addr => {
      addr.country_id = addr.country_code
    })
    state.current = admin
  },
  setAddresses (state, addresses) {
    state.addresses = addresses.map((address, index) => {
      return {
        id: index,
        ...address
      }
    })
  },
  setAddressSelected (state, address) {
    state.addressSelected = address
  },
  setOnlineStoreCode (state, code) {
    state.onlineStoreCode = code
  },
  setAdminRole (state, adminRole) {
    state.role = adminRole
  },
  setCoupons (state, coupons) {
    state.coupons = coupons
  }
}
